/**
 * @class BaseSocket
 * @implements {ISocket}
 * @abstract
 * Необходим для создания собственных реализаций сокета
 * (например обмен по xhr с помощью axios- AxiosSocket)
 * Все экземпляры дочерних классаов должны реализовывать интерфейс {@link ISocket},
 * чтобы быть совместимыми с нативным {@link WebSocket}
 */
export class BaseSocket {
    constructor() {
        this.onclose = (_e) => void 0;
        this.onerror = (_e) => void 0;
        this.onmessage = (_e) => void 0;
        this.onopen = (_e) => void 0;
    }
    get readyState() {
        throw new Error('Нет состояния подключения у BaseSocket');
    }
    send(_s) {
        throw new Error('Невозможно создать экземпляр абстрактного класса');
    }
}
export var CONNECTION_STATE;
(function (CONNECTION_STATE) {
    CONNECTION_STATE[CONNECTION_STATE["CONNECTING"] = 0] = "CONNECTING";
    CONNECTION_STATE[CONNECTION_STATE["CLOSED"] = 3] = "CLOSED";
    CONNECTION_STATE[CONNECTION_STATE["CLOSING"] = 2] = "CLOSING";
    CONNECTION_STATE[CONNECTION_STATE["OPEN"] = 1] = "OPEN";
})(CONNECTION_STATE || (CONNECTION_STATE = {}));



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/connector/socketListener/socket/BaseSocket.js